import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import UpdatePreview from './updates/UpdatePreview';
import { Button, Card } from '@paypalcorp/pp-react';
import { trackOrganizerUpdatesListIM } from '../../fpti/fpti';
import GenericInternalServiceError from '../../pages/error/genericInternalServiceError';

const OrganizerUpdatesList = (props) => {
  const {
    organizerUpdates,
    handleUpdatePreviewCardClick,
    setCurrentUpdate,
    setShowLikeError,
    renderShowMoreUpdatesLink,
    getOrganizerUpdatesContent,
    isLoading,
    isListError,
    fetchNextUpdates,
  } = props;

  useEffect(() => {
    trackOrganizerUpdatesListIM(organizerUpdates?.length);
  }, []);

  return (
    organizerUpdates?.length && (
      <div
        className="organizer-updates-list"
        data-testid="organizer-updates-list"
      >
        {organizerUpdates.map((organizerUpdate) => (
          <div
            className="organizer-update-preview"
            key={organizerUpdate.fou_id}
          >
            <UpdatePreview
              handleUpdatePreviewCardClick={handleUpdatePreviewCardClick}
              update={organizerUpdate}
              setCurrentUpdate={setCurrentUpdate}
              setShowLikeError={setShowLikeError}
            />
          </div>
        ))}

        {isListError ? (
          <GenericInternalServiceError
            id="common.genericError.error.update.loadUpdates"
            handleRetry={() => fetchNextUpdates(false)}
          />
        ) : (
          <div className="text-center">
            {renderShowMoreUpdatesLink() && (
              <Button onClick={() => fetchNextUpdates(true)} tertiary>
                {getOrganizerUpdatesContent('updates.showPreviousUpdates')}
              </Button>
            )}
          </div>
        )}
        {isLoading && (
          <div style={{ height: '13rem' }}>
            <Card isLoading></Card>
          </div>
        )}
      </div>
    )
  );
};

OrganizerUpdatesList.propTypes = {
  organizerUpdates: PropTypes.array,
  handleUpdatePreviewCardClick: PropTypes.func,
  setCurrentUpdate: PropTypes.func,
  setShowLikeError: PropTypes.func,
  renderShowMoreUpdatesLink: PropTypes.func,
  getOrganizerUpdatesContent: PropTypes.func,
  isLoading: PropTypes.bool,
  isListError: PropTypes.bool,
  fetchNextUpdates: PropTypes.func,
};

export default OrganizerUpdatesList;
